import * as React from "react";
const SvgFiRrSquareW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-w_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM18.988 6.152l-1.749 11.354C17.117 18.304 16.5 19 15.488 19a1.74 1.74 0 0 1-1.634-1.122L12 13.114l-1.854 4.764a1.77 1.77 0 0 1-1.836 1.111 1.744 1.744 0 0 1-1.549-1.484L5.012 6.152a1 1 0 1 1 1.977-.305l1.614 10.48 2.466-6.333a1 1 0 0 1 1.864 0l2.466 6.333 1.614-10.48a1 1 0 1 1 1.977.305z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-w_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareW;
